export default "__VITE_ASSET__CyzkW7In__"